import BaseComponent from 'foundation/base-component';
import app from 'general/js/app';
import modalSpa from 'general/js/modal-spa';

export default class ModalSpaTrigger extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.url = this.element.getAttribute('href') || this.element.getAttribute('data-href') || this.getAttribute(this.element, 'href');

        this.init();
    }

    init() {
        this.addListener(this.element, 'click', this.onClickElement);
    }

    onClickElement = (event) => {
        if (!app.isEditMode) {
            modalSpa.open({
                url: this.url,
                openLinkInPopup: this.options.openLinkInPopup
            });
        }
        event.preventDefault();
    }
}
